// extracted by mini-css-extract-plugin
export var barContainer = "_49-0";
export var extraThin = "_49-3";
export var fillBar = "_49-6";
export var fillContainer = "_49-4";
export var overflow = "_49-8";
export var overflowContainer = "_49-5";
export var regular = "_49-7";
export var thick = "_49-1";
export var thin = "_49-2";